import { createSlice } from '@reduxjs/toolkit';
import { client } from '../../shared/apollo';
import { CREATE_COMPLETED_TOURS_MUTATION, FETCH_MANY_COMPLETED_TOURS_QUERY } from './queries';

export const toursSlice = createSlice({
  name: 'toursSlice',
  initialState: {
    completedTours: [],
    openTourModal: false,
  },
  reducers: {
    setCompletedToursReducer: (state, action) => {
      state.completedTours = action.payload;
    },
    saveCompletedToursReducer: (state, action) => {
      const newCompletedTours = [...state.completedTours, { ...action.payload }];
      state.completedTours = newCompletedTours;
    },
    setOpenTourModal: (state, action) => {
      state.openTourModal = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setCompletedToursReducer, saveCompletedToursReducer } = toursSlice.actions;
export const { reducer: toursReducer } = toursSlice;

export const fetchCompletedToursAction = async (input, dispatch) => {
  const { user } = input;
  let result;

  // eslint-disable-next-line prefer-const
  result = await client.query({
    query: FETCH_MANY_COMPLETED_TOURS_QUERY,
    variables: { where: { userId: { equals: user.id } } },
  });
  dispatch(setCompletedToursReducer(result.data.completedTours));
};

export const saveCompletedTourAction = async (input, dispatch) => {
  const { name, userId } = input;
  let result;
  try {
    result = await client.mutate({
      mutation: CREATE_COMPLETED_TOURS_MUTATION,
      variables: { data: { name, userId } },
    });

    dispatch(saveCompletedToursReducer(result.data.createOneCompletedTour));
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (e) {
    // console.error('saveCompletedTours:error:', e);
  }
};
